var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { PromiseUtils } from "@kv-design/kui";
export default class HttpRequest {
    static async request(config) {
        const _a = Object.assign({}, HttpRequest.defaultConfig, config), { withSuccess = false, waitHandler, logger } = _a, httpConfig = __rest(_a, ["withSuccess", "waitHandler", "logger"]);
        if (typeof waitHandler === "function") {
            await PromiseUtils.wait(waitHandler.bind(this, config));
        }
        try {
            const res = await HttpRequest.requestHandler(httpConfig);
            const data = res.data;
            if (res.statusCode >= 400) {
                await Promise.reject(res);
            }
            else {
                if (logger) {
                    HttpRequest.printSuccess(config, data);
                }
            }
            return Promise.resolve(withSuccess ? [true, data] : data);
        }
        catch (error) {
            if (logger) {
                HttpRequest.printError(config, error);
            }
            return withSuccess ? Promise.resolve([false, error]) : Promise.reject(error);
        }
    }
}
HttpRequest.defaultConfig = {
    logger: true,
};
HttpRequest.config = (config) => {
    const { requestHandler } = config;
    HttpRequest.requestHandler = requestHandler;
};
HttpRequest.printSuccess = (config, response) => {
    const { url, data } = config;
    console.groupCollapsed(`%c[KV Design] HttpRequest Success  =>  ${url}`, "color:#00e676;font-weight:bold;");
    console.log(`%cParameters  =>  `, "font-weight:bold;", HttpRequest.copyTarget(data));
    console.log(`%cConfig  =>  `, "color:#9E9E9E;font-weight:bold;", HttpRequest.copyTarget(config));
    console.log(`%cResponse  =>  `, "color:#00e676;font-weight:bold;", HttpRequest.copyTarget(response));
    console.groupEnd();
};
HttpRequest.printError = (config, error) => {
    const { url, data } = config;
    console.groupCollapsed(`%c[KV Design] HttpRequest Error  =>  ${url}`, "color:#F44336;font-weight:bold;");
    console.log(`%cParameters  =>  `, "font-weight:bold;", HttpRequest.copyTarget(data));
    console.log("%cConfig:", "color:#9E9E9E;font-weight:bold;", HttpRequest.copyTarget(config));
    console.log("%cError:", "color:#F44336;font-weight:bold;", HttpRequest.copyTarget(error));
    console.groupEnd();
};
HttpRequest.copyTarget = (target) => {
    if (typeof target === "string") {
        return target;
    }
    return Object.assign({}, target);
};
